/**
 * @generated SignedSource<<6b9794dabeb1cdd811b4e82bd34c6f9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewDesktop_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenAttendCard_query" | "EventScreenJoin_query" | "SponsorsSection_query">;
  readonly " $fragmentType": "EventScreenNewDesktop_query";
};
export type EventScreenNewDesktop_query$key = {
  readonly " $data"?: EventScreenNewDesktop_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewDesktop_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewDesktop_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4cb3a460b82bb24f47f1ede58f3efce2";

export default node;
